var exports = {
  "z": "x93eb46d8--b88f50--root",
};

module.exports = exports;
